"use client";

import {Box, Flex, HStack, Stack, Text} from "@chakra-ui/react";
import Button from "../components/Button";
import Footer from "../components/Footer";
import {Header} from "../components/Header";
import Heading from "../components/Heading";
import {HeroContainer} from "../components/Hero";
import {useRouter} from "next/navigation";

const Error404 = () => {
  const router = useRouter();

  return (
    <Flex direction="column" minH="100vh">
      <Header light={false} />
      <Box as="main" flex={1}>
        <HeroContainer minH="full">
          <Stack gap={8}>
            <Heading>
              <Text
                color="blue.500"
                display="inline"
                fontWeight="600"
                borderRight="1px solid"
                borderColor="gray.200"
                pr={4}
                mr={4}
              >
                404
              </Text>
              Page not found
            </Heading>
            <Text color="gray.500">Please check the URL in the address bar and try again.</Text>
            <HStack gap={2}>
              <Button colorPalette="blue" onClick={() => router.back()}>
                Go Back
              </Button>
              <Button href="mailto:support@platformed.com">Contact support</Button>
            </HStack>
          </Stack>
        </HeroContainer>
      </Box>
      <Footer />
    </Flex>
  );
};

export default Error404;
